import React, { Component } from "react";
import { connect } from "react-redux";

import $ from "jquery";

import * as sisMapActions from "store/modules/rds_sisMap";
import * as layoutActions from "store/modules/rds_layout";

import SisModal from "store/sis/sisModal";
import ColorPicker from "store/sis/component/ColorPicker";

import "./layerOption.scss";
import { bindActionCreators } from "redux";

class LayerOption extends Component {
	state = {
		width: 1,
		color: "#000000",
		opacity: 1,
		layer: null,
	};

	componentDidMount() {
		const { LayoutActions } = this.props;

		LayoutActions.setModal({
			id: "layerOptionModal",
			target: this,
		});
	}

	componentDidUpdate() {
		const modal = this.props.layout.get("layerOptionModal");
		this.props.sis.sisTree.optionModal = modal;
	}

	setLayer = (layer) => {
		this.setState({
			layer,
			color: "#000000",
			width: 1,
			opacity: 1,
		});

		this.colorPicker.refresh();
		this.modal.show();
	};

	refresh = () => {
		this.setState({
			color: "#000000",
			width: 1,
			opacity: 1,
		});
		this.colorPicker.refresh();
	};

	setStyle = () => {
		const { layer, color, width, opacity } = this.state;

		if (layer) {
			const source = layer.getSource();
			let label = "";

			$.ajax({
				url: "/map/getLayerLabel",
				type: "post",
				async: false,
				data: {
					id: layer.get("id"),
				},
				success: (res) => {
					if (res) {
						label = `label:${res.engName};`;
					}
				},
			});

			source.updateParams({
				STYLES: "dynamic",
				env: `${label}fillColor:${color.replace("#", "")};lineColor:${color.replace("#", "")};pointColor:${color.replace("#", "")};lineWidth:${parseFloat(width)};pointSize:${parseFloat(width)};fillOpacity:${parseFloat(
					opacity
				)};lineOpacity:${parseFloat(opacity)};pointOpacity:${parseFloat(opacity)}`,
			});
		}
	};

	render() {
		let arrFontSize = [];

		for (var i = 8; i <= 30; i++) {
			arrFontSize.push({
				key: i,
				text: i,
			});
		}

		return (
			<div>
				<SisModal
					id={this.props.id}
					title="레이어 설정"
					ref={(ref) => (this.modal = ref)}
					closeEvent={this.refresh}
					contents={
						<div style={{ padding: "0px 15px" }}>
							<div className="optionWrap">
								<span className="layerName">{this.state.layer ? this.state.layer.get("korName") : ""}</span>
							</div>

							<div className="optionWrap">
								<ColorPicker
									id="layerColor"
									ref={(ref) => (this.colorPicker = ref)}
									label
									defaultColor={this.state.color}
									onChange={(color) => {
										this.setState({
											color,
										});
									}}
								/>
							</div>

							<div className="optionWrap">
								<span>크기/두께</span>
								<label>
									<input
										type="number"
										value={this.state.width}
										step={1}
										min={1}
										max={10}
										onChange={(evt) => {
											let val = parseInt(evt.target.value);
											const max = parseInt(evt.target.max);
											const min = parseInt(evt.target.min);

											if (val > max) val = max;
											if (val < min) val = min;

											this.setState({
												width: val,
											});
										}}
									/>
								</label>
							</div>

							<div className="optionWrap">
								<span>투명도</span>
								<label>
									<input
										type="number"
										value={this.state.opacity}
										step={0.1}
										min={0}
										max={1}
										onChange={(evt) => {
											let val = parseFloat(evt.target.value);
											const max = parseFloat(evt.target.max);
											const min = parseFloat(evt.target.min);

											if (val > max) val = max;
											if (val < min) val = min;

											this.setState({
												opacity: val,
											});
										}}
									/>
								</label>
							</div>

							<div className="optionWrap" style={{ textAlign: "center" }}>
								<button onClick={this.setStyle}>적용하기</button>
							</div>
						</div>
					}
				/>
			</div>
		);
	}
}

export default connect(
	(state) => ({
		layout: state.layout,
		sis: state.sisMap,
	}),
	(dispatch) => ({
		SisMapActions: bindActionCreators(sisMapActions, dispatch),
		LayoutActions: bindActionCreators(layoutActions, dispatch),
	})
)(LayerOption);
